export default __webpack_public_path__ + "static/media/1542.e644a26d.png";